import { render, staticRenderFns } from "./Error.vue?vue&type=template&id=6e7ca84a&scoped=true&"
var script = {}
import style0 from "./Error.vue?vue&type=style&index=0&id=6e7ca84a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6e7ca84a",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\Trabalho\\Lupa Soluções em TI\\Clientes\\Leonardo Raton\\Site\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6e7ca84a')) {
      api.createRecord('6e7ca84a', component.options)
    } else {
      api.reload('6e7ca84a', component.options)
    }
    module.hot.accept("./Error.vue?vue&type=template&id=6e7ca84a&scoped=true&", function () {
      api.rerender('6e7ca84a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/pages/Checkout/components/steps/Error.vue"
export default component.exports